// extracted by mini-css-extract-plugin
export default {"Box":"selected-repository-pill-module__Box--CzvxL","Text":"selected-repository-pill-module__Text--jXGYR","Text_1":"selected-repository-pill-module__Text_1--N4R8o"};